import { NavigationGuard } from 'vue-router';
import store from '@/store';
import { tRoute } from '@/utils/plugins/i18nRoutes';
import { RouteNames } from '@/utils/router/router.models';

export const codeGuard: NavigationGuard = async (to, _from, next) => {
  await store.dispatch('notify/resetState');
  await store.dispatch('configuration/setTypes');
  await store.dispatch('configuration/setConfigurationByCode', to.params.code);

  next(tRoute(RouteNames.HouseSize));
};
